import {DAY_MS, iso, makeShareToken, country, MOCK_ICCID, MOCK_DOMAIN_ID, MOCK_ACTIVATION_CODE, MOCK_RESELLER_INFORMATION} from "./shared";

const UK_COUNTRIES = [country("GB", "United Kingdom")];

// "Empty data, good validity" demo: installed, only ~14% of a 14-day
// validity window elapsed (would read comfortably green on its own), but the
// full 3GB package is already used up - the ring should render empty/grey
// (0 GB left) while the expiry bar stays red/critical, and the usage panel
// should swap to the "no data remaining" wording.
function dates() {
    return {
        activatedAt: iso(-2 * DAY_MS),
        expiresAt: iso(-2 * DAY_MS + 14 * DAY_MS),
        salesDate: iso(-2 * DAY_MS - 60 * 60 * 1000)
    };
}

export function getMockCustomerProfile() {
    const {activatedAt, expiresAt, salesDate} = dates();

    return {
        totalAvailableBalance: {sizeValue: 0, sizeUnit: "GB"},
        balances: [
            {
                price: {priceValue: 9.99, currencyCode: "USD"},
                salesDate,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                includedCountries: UK_COUNTRIES,
                balance: {
                    name: "UK Data Pack",
                    activatedAt,
                    expiresAt,
                    activationMode: "NOW",
                    size: {sizeValue: 3, sizeUnit: "GB"},
                    availableBalance: {sizeValue: 0, sizeUnit: "GB"},
                    validitySize: 14, validityUnit: "days",
                    countrySet: "gb",
                    extendedDataPolicy: null
                }
            }
        ],
        relatedEsims: [
            {
                uid: "esim-uid-002",
                active: true,
                state: "Installed",
                iccid: MOCK_ICCID,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                activatedAt,
                lastSeen: iso(-5 * 60 * 1000),
                installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
                appleUniversalLink: "https://example.com/esim/apple-install",
                androidUniversalLink: "https://example.com/esim/android-install",
                activationCode: MOCK_ACTIVATION_CODE,
                imsi: ""
            }
        ],
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}

export function getMockEsimData() {
    const {activatedAt, expiresAt} = dates();

    return {
        esimProfile: {
            uid: "esim-uid-002",
            active: true,
            state: "Installed",
            iccid: MOCK_ICCID,
            customerProfileDomainId: MOCK_DOMAIN_ID,
            activatedAt,
            lastSeen: iso(-5 * 60 * 1000),
            installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
            appleUniversalLink: "https://example.com/esim/apple-install",
            androidUniversalLink: "https://example.com/esim/android-install",
            activationCode: MOCK_ACTIVATION_CODE,
            imsi: ""
        },
        balances: [
            {
                name: "UK Data Pack",
                activatedAt,
                expiresAt,
                activationMode: "NOW",
                size: {sizeValue: 3, sizeUnit: "GB"},
                availableBalance: {sizeValue: 0, sizeUnit: "GB"},
                validitySize: 14, validityUnit: "days",
                countrySet: "gb",
                extendedDataPolicy: null
            }
        ],
        totalAvailableBalance: {sizeValue: 0, sizeUnit: "GB"},
        customerProfileUrl: "https://example.com/customer/profile?token=mock-customer-token",
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}
